import { http } from '@/api/http'
import type { RequestOptions } from '../crud'

/** One place that uses a record: a stable code (orders, warehouse_documents, finance…) and how many rows. */
export type RecordUsage = { where: string; count: number }

export type RecordUsageResponse = { in_use: boolean; usages: RecordUsage[] }

/**
 * Where a reference record is used. A used record cannot be deleted and only
 * its names and status change (owner decision 2026-10-09); the server enforces
 * it, the form reads this to lock itself beforehand.
 */
export const usageService = {
  async get(kind: string, id: string, options?: RequestOptions) {
    const { data } = await http.get<RecordUsageResponse>(`/usage/${encodeURIComponent(kind)}/${encodeURIComponent(id)}`, options)
    return { in_use: Boolean(data.in_use), usages: data.usages ?? [] }
  },
}
